import React from 'react';
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { environment } from './environments/environment';
import Routes from './routes/routes';

const client = new ApolloClient({
  uri: `${environment.graphqlUri}`,
  credentials: 'same-origin',
  cache: new InMemoryCache()
})

function App() {
  return (
    <ApolloProvider client={client}>
      <Routes />
    </ApolloProvider>
  );
}

export default App;
